import { Typography, useTheme } from "@mui/material";
import { CommonBar } from "../utils/commonbar";
import { formatDate } from "../utils/formatters";

export const PricingHealthPanel = ({ data, selectedMetric, onMetricClick }) => {
  const theme = useTheme();
    const dims = theme.dimensions;
  const panelTheme = theme.palette.contentPanel;

  const health = {
    priceRealization: {
        data: [{
            percent: 82,
            color: theme.palette.status.warning
        }],
        total: { impact: "2.5", marginPct: 2 }
    },
    costPassThruRate: {
        data: [{
            percent: 84,
            color: theme.palette.heatmap.warning.medium
        }],
        total: { impact: "4.5", marginPct: 3 }
    },
    freightRecoveryRate: {
        data: [{
            percent: 92,
            color: theme.palette.status.success
        }],
        total: { impact: "0.5", marginPct: 0.5 }
    },
    lastPriceIncrease: {
        date: "2024-11-15",
        daysSince: 79,
        total: { impact: "3.5", marginPct: 2 }
    }
  };

  const calculateDaysSince = (dateString) => {
    const lastDate = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today - lastDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const renderClickableRow = (label, metricKey, data, impact, marginPct) => {
    const isSelected = selectedMetric === metricKey;

    return (
      <div
        key={label}
        onClick={() => onMetricClick(metricKey)}
        style={{
          display: "grid",
          gridTemplateColumns: "1fr minmax(100px, 250px) 0.3fr 0.3fr",
          gap: 8,
          alignItems: "center",
          minHeight: 36,
          padding: "4px 5px",
          margin: 5,
          cursor: "pointer",
          borderRadius: 4,
          border: isSelected ? `1px solid ${theme.palette.primary.main}` : "1px solid transparent",
        }}
      >
        <Typography variant="body2" sx={{ textAlign: "right", marginRight: 2 }}>
          {label}
        </Typography>

        <CommonBar height={30} data={data} />

        <Typography
          variant="body2"
          style={{
            fontSize: 12,
            fontWeight: 500,
            textAlign: "right",
          }}
        >
          ${impact}M
        </Typography>

        <Typography
          variant="body2"
          style={{
            fontSize: 12,
            fontWeight: 500,
            textAlign: "right",
          }}
        >
          {marginPct}%
        </Typography>
      </div>
    );
  };

  const renderLastPriceIncreaseRow = () => {
    const { date, daysSince, total } = health.lastPriceIncrease;
    const days = daysSince || calculateDaysSince(date);
    const formattedDate = formatDate(date);
    const maxDays = 365;
    const barPercent = Math.min((days / maxDays) * 100, 100);

    return (
      <div
        key="lastPriceIncrease"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr minmax(100px, 250px) 0.3fr 0.3fr",
          gap: 8,
          alignItems: "center",
          minHeight: 36,
          padding: "4px 0",
          margin: 5,
        }}
      >
        <Typography variant="body2" sx={{ textAlign: "right", marginRight: 2 }}>
          Last Price Increase
        </Typography>

        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <div style={{
            height: 30,
            backgroundColor: "#e0e0e0",
            border: `2px solid #323D72`,
            overflow: "hidden",
            position: "relative"
          }}>
            <div style={{
              height: "100%",
              borderRight: `2px solid #323D72`,
              width: `${barPercent}%`,
              backgroundColor: theme.palette.status.success
            }} />
          </div>
          <Typography variant="caption" style={{ fontSize: 12, textAlign: "center" }}>
            {days} days ago ({formattedDate})
          </Typography>
        </div>

        <Typography
          variant="body2"
          style={{
            fontSize: 12,
            fontWeight: 500,
            textAlign: "right",
          }}
        >
          ${total.impact}M
        </Typography>

        <Typography
          variant="body2"
          style={{
            fontSize: 12,
            fontWeight: 500,
            textAlign: "right",
              paddingRight: 6
          }}
        >
          {total.marginPct}%
        </Typography>
      </div>
    );
  };

  return (
    <div style={{ ...panelTheme, marginTop: 30, padding: 10, width: '100%', minHeight: dims.smallPanelHeight}}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr minmax(100px, 250px) 0.3fr 0.3fr",
          alignItems: "center",
          paddingBottom: 8,
        }}
      >
        <Typography variant="h5" display="inline" style={{ marginLeft: 10 }}>
          Pricing Health
        </Typography>
        <div />
        <Typography
          variant="body2"
          style={{
            fontWeight: 700,
            fontSize: 12,
            textDecoration: "underline",
            textAlign: "right",
          }}
        >
          Margin Impact
        </Typography>
        <Typography
          variant="body2"
          style={{
            fontWeight: 700,
            fontSize: 12,
            textDecoration: "underline",
            textAlign: "right",
          }}
        >
          % of Margin
        </Typography>
      </div>

      {renderClickableRow("Price Realization", "priceRealization", health.priceRealization.data, health.priceRealization.total.impact, health.priceRealization.total.marginPct)}
      {renderClickableRow("Cost Pass Thru Rate", "costPassThruRate", health.costPassThruRate.data, health.costPassThruRate.total.impact, health.costPassThruRate.total.marginPct)}
      {renderClickableRow("Freight Recovery Rate", "freightRecoveryRate", health.freightRecoveryRate.data, health.freightRecoveryRate.total.impact, health.freightRecoveryRate.total.marginPct)}
      {renderLastPriceIncreaseRow()}
    </div>
  );
};